import { render, staticRenderFns } from "./form-punch.vue?vue&type=template&id=bd22f6c2&"
import script from "./form-punch.vue?vue&type=script&lang=js&"
export * from "./form-punch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports